const CloverSalesApis={
    processExcel:'https://j9lgs2gwp1.execute-api.us-east-1.amazonaws.com/UAT/processExcel',
    previewExcelData:'https://j9lgs2gwp1.execute-api.us-east-1.amazonaws.com/UAT/UATFACPreviewExcelSalesData',
    nonCloverSalesUpdateSP:'https://j9lgs2gwp1.execute-api.us-east-1.amazonaws.com/UAT/UATFACNonCloverSalesUpdateSP',
    fetchYearWeeks:'https://j9lgs2gwp1.execute-api.us-east-1.amazonaws.com/UAT/FetchYearWeeks'
}

export default CloverSalesApis